import { render, staticRenderFns } from "./SearchComplaint.vue?vue&type=template&id=6cd6e10a&"
import script from "./SearchComplaint.vue?vue&type=script&lang=js&"
export * from "./SearchComplaint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports